var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "email icon",
    d: "M3.75 30C2.71875 30 1.83594 29.6328 1.10156 28.8984C0.367188 28.1641 0 27.2812 0 26.25V3.75C0 2.71875 0.367188 1.83594 1.10156 1.10156C1.83594 0.367188 2.71875 0 3.75 0H33.75C34.7812 0 35.6641 0.367188 36.3984 1.10156C37.1328 1.83594 37.5 2.71875 37.5 3.75V26.25C37.5 27.2812 37.1328 28.1641 36.3984 28.8984C35.6641 29.6328 34.7812 30 33.75 30H3.75ZM18.75 16.875L33.75 7.5V3.75L18.75 13.125L3.75 3.75V7.5L18.75 16.875Z",
    fill: "#000A18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailicon);
export default __webpack_public_path__ + "static/media/email icon.cf6279b6d15429abe71e3a276a877d25.svg";
export { ForwardRef as ReactComponent };